import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=c7fd0e9a&"
import script from "./Leaderboard.vue?vue&type=script&lang=js&"
export * from "./Leaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7fd0e9a')) {
      api.createRecord('c7fd0e9a', component.options)
    } else {
      api.reload('c7fd0e9a', component.options)
    }
    module.hot.accept("./Leaderboard.vue?vue&type=template&id=c7fd0e9a&", function () {
      api.rerender('c7fd0e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Leaderboard.vue"
export default component.exports